import { put, call, takeLatest, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import cartAPI from '../../api/cart';
import { Creators as CartCreators, Types } from '../../reducers/cart';
import { Creators as DeliveryCreators } from '../../reducers/delivery';
import { Creators as FreightCreators } from '../../reducers/freights';
import { Creators as StoresCreators } from '../../reducers/stores';
import { getCartId, setCartId } from '../../utils/cookies';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* cartRequest({ cid, token }) {
  try {
    const { cart, customer, app } = yield select(getState);
    const customerToken = (yield select(getToken)) || token;
    const cartId = cid || cart.id || customer.cartId || getCartId();
    const siteId = app.getIn(['config', 'siteId']);
    const domain = app.getIn(['config', 'domain']);

    if (!cartId) {
      throw new Error('Nenhum carrinho encontrado');
    }

    const data = yield call(cartAPI.getCart, cartId, customerToken, siteId);

    if (data.id) setCartId(data.id, domain);

    if (data.sellers) {
      const selectedFreight = {};
      const selectedStore = {};
      const selectedDelivery = {};

      data.sellers.forEach((seller) => {
        if (seller.freight) {
          selectedFreight[seller.seller?.id] = seller.freight;
          selectedDelivery[seller.seller?.id] = { isFreight: true, ...seller.freight };
        }

        if (seller.idStoreRetrieve) {
          selectedStore[seller.seller?.id] = { id: seller.idStoreRetrieve };
          selectedDelivery[seller.seller?.id] = { isStore: true };
        }
      });

      yield put(DeliveryCreators.selectDelivery(selectedDelivery));
      yield put(StoresCreators.selectStore(selectedStore));
      yield put(FreightCreators.selectFreight(selectedFreight));
    }

    yield put(CartCreators.cartSuccess(data));
  } catch (error) {
    yield put(CartCreators.cartFailed(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.CART_REQUEST, cartRequest);
}
